<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >

      <div class="form_title">基本信息</div>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="活动名称"
                       :label-col="{ span: 2 }"
                       :wrapper-col="{ span: 20 }">
            <a-textarea v-decorator="['fissionName',rules.fissionName]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="活动时间"
                       :label-col="{ span: 2 }"
                       :wrapper-col="{ span: 8 }">
            <a-range-picker show-time v-decorator="['fissionTime',rules.fissionTime]"
                            :valueFormat="'YYYY-MM-DD HH:mm:ss'"></a-range-picker>
          </a-form-item>
        </a-col>
      </a-row>
      <div class="form_title">兑奖设置</div>
      <roleTable ref="roleTable"></roleTable>
      <div class="form_title">裂变文案</div>
      <div class="text_editer">
        <div>
          <span>添加变量：</span>
          <a-button type="link" @click="insert('@「员工名称」',0)">员工名称</a-button>
        </div>
        <chatInput ref="chatInput" v-model="fissionContent" class="chatInput"/>
        <div>新用户添加裂变成员时自动发送此文案和裂变海报</div>
      </div>
      <div class="form_title">结束文案</div>
      <div class="text_editer">
        <chatInput ref="chatInput2" v-model="fissionEndContent" class="chatInput"/>
        <div>活动结束后3天内，新用户通过活动添加裂变员工时自动发送此文案</div>
      </div>
      <div class="form_title">助力限制</div>
      <div>
        <a-switch
            v-model="isNewAssist"
            checked-children="是"
            un-checked-children="否"
            style="margin: -8px 10px 0"
        />
        <h3 style="display: inline-block">新客户才能助力</h3>
        （若客户在活动前已添加过企业任意员工，该客户将不被计入助力次数）
      </div>
      <div>欢迎语文案设置：</div>
      <div class="text_editer">
        <div>
          <span>添加变量：</span>
          <a-button type="link" @click="insert('@「员工名称」',2)" v-show="isNewAssist">员工名称</a-button>
          <a-button type="link" v-show="!isNewAssist">员工名称</a-button>
        </div>
        <chatInput ref="chatInput1" v-model="fissionNewContent" class="chatInput" :editable="isNewAssist"/>
        <div>新用户添加裂变成员时自动发送此文案和裂变海报</div>
      </div>
      <div class="form_title">分享信息</div>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="分享标题"
                       :label-col="{ span: 2 }"
                       :wrapper-col="{ span: 20 }">
            <a-input v-decorator="['shareTitle',rules.shareTitle]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="分享文案"
                       :label-col="{ span: 2 }"
                       :wrapper-col="{ span: 20 }">
            <a-textarea v-decorator="['shareDescribe',rules.shareDescribe]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="分享图片"
                       :label-col="{ span: 2 }"
                       :wrapper-col="{ span: 20 }">
            <uploader :num="1" v-decorator="['shareImg',rules.shareImg]" :accept="'image/*'"
                      :url="api.temp.UPLOAD_PATH"
            ></uploader>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="submit">下一步</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin, fmt} from '@/utils/common/FormBase'

console.log(fmt)
//厂商用户管理接口
import roleTable from './roleTable'
import chatInput from "./chatInput";
import {dataApi} from "@/services/operate/marketingFission";


/**
 * 加载规则 必填控制我
 */
function getRulesTemplate() {
  return {
    fissionName: {
      rules: [{required: true, message: "请输入活动名称"}]
    },
    fissionTime: {
      rules: [{required: true, message: "请选择活动时间"}]
    },
    shareTitle: {
      rules: [{required: true, message: "请输入分享标题"}]
    },
    shareDescribe: {
      rules: [{required: true, message: "请输入分享文案"}]
    },
    shareImg: {
      rules: [{required: true, message: "请上传分享图片"}]
    }
  };
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    notify: true
  };
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  entity.data.fissionTime = [entity.data.startTime, entity.data.endTime]
  this.fissionContent = entity.data.fissionContent
  this.fissionEndContent = entity.data.fissionEndContent
  this.fissionNewContent = entity.data.fissionNewContent
  this.isNewAssist = entity.data.isNewAssist === 1
  this.$refs['roleTable'].loadData(entity.data.prizeList);
  return fmt.formatFormLoad(entity);
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  console.log(entity)
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function submit() {
  let entities = null
  const vm = this
  this.form.validateFieldsAndScroll((err, values) => {
    if (!err) {//无任何错误 向下执行
      entities = values;
    }
  });
  entities.startTime = entities.fissionTime[0]
  entities.endTime = entities.fissionTime[1]
  const reg = new RegExp('<span>', "g")
  const reg1 = new RegExp('</span>', "g")
  const reg2 = new RegExp('<br />', "g")
  const reg3 = new RegExp('<div>', "g")
  const reg4 = new RegExp('</div>', "g")
  entities.fissionContent = vm.fissionContent.replace(reg, '').replace(reg1, '',).replace(reg2, '',).replace(reg3, '',).replace(reg4, '\n',)
  entities.fissionEndContent = vm.fissionEndContent.replace(reg3, '',).replace(reg4, '\n',)
  if (this.fissionNewContent) {
    entities.fissionNewContent = vm.fissionNewContent.replace(reg, '').replace(reg1, '',).replace(reg2, '',).replace(reg3, '',).replace(reg4, '\n',)
  } else {
    entities.fissionNewContent = ''
  }
  vm.$refs["roleTable"].getChildData((child, del) => {
    entities.addPrizeList = child;
    entities.delPrizeList = del.map(item => {
      return item.prizeId
    });
  });
  entities.fissionId = vm.rowId
  entities.isNewAssist = vm.isNewAssist ? 1 : 0
  console.log(entities)
  await dataApi.saveFormDetail(entities).then(res => {
    if (res.code === 200) {
      this.$emit('nextStep', res.data.fissionId)
    } else {
      this.$message.error(res.msg)
    }
  })
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {roleTable, chatInput},
  data() {
    return {
      fissionTime: [],
      fissionContent: '您好，@「员工名称」邀请您参与本次福利活动，点击下方图文，邀请好友扫码助力，添加@「员工名称」为好友：让更多人员为你助力并添加@「员工名称」好友，即可领取奖品！奖品数量有限，先到先得哦！快去分享你的专属海报吧！',
      fissionEndContent: '活动已结束',
      fissionNewContent: '您已经是我们的老朋友啦，无法给朋友助力哦～ ----------点击下方图文，邀请好友扫码助力，添加@「员工名称」为好友：让更多人员为你助力并添加@「员工名称」好友，即可领取奖品！奖品数量有限，先到先得哦！快去分享你的专属海报吧！',
      isNewAssist: true
    }
  },
  mounted() {

  },
  methods: {
    loadEntity,
    newEntity,
    submit,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
    insert(text, index) {
      // var dom = document.createElement('span');
      // dom.className = 'name';
      // dom.innerHTML = text;
      document.getElementsByClassName('chatInput')[index].focus()
      const vm = this
      this.$nextTick(() => {
        if (index === 2) {
          console.log(text)
          vm.$refs.chatInput1.insertHtmlAtCaret(text)
        } else {
          console.log(text)
          vm.$refs.chatInput.insertHtmlAtCaret(text)
        }
      })
    },
    cancel() {
      this.$emit('cancel')
    }
  }
};
</script>
